import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const useNavigateWithSearch = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  const navigateWithSearch = useCallback((path, options = {}) => {
    navigate(`${path}${search}`, options);
  }, [ navigate, search ]);

  return navigateWithSearch;
};

export default useNavigateWithSearch;